const RETURN_TO_KEY = "ncc.auth.returnTo";

/**
 * Chữ ký tham số của một callback uỷ quyền OIDC. Cố ý mô phỏng ĐÚNG phép kiểm của
 * keycloak-js (`#parseCallbackUrl`: `(code || error) && state`) để hai bên nhận diện
 * cùng một tập URL.
 *
 * Khớp THEO THAM SỐ chứ không theo chuỗi con — `#realestate=1&zipcode=2` chứa "state"
 * và "code" nhưng không phải tham số `state`/`code`.
 */
function isOidcCallbackParams(params: URLSearchParams): boolean {
  return params.has("state") && (params.has("code") || params.has("error"));
}

/**
 * Cắt chất liệu OIDC khỏi URL trước khi nó kịp thành "trang cần quay về".
 *
 * keycloak-js trả kết quả uỷ quyền trong `#` (`responseMode = 'fragment'` là mặc định và
 * app không override), nên URL callback trông như `/trang-b#state=…&code=…`. Để nguyên thì
 * fragment đó được lưu rồi `history.replaceState` ghi trả lại thanh địa chỉ — đúng lỗi
 * đang vá. Xử lý luôn dạng query (`/?state=…&code=…`) để hai bên không lệch nhau.
 *
 * Bỏ CẢ fragment khi nó là callback (phần còn lại của một fragment callback không có nghĩa
 * gì với app). Với dạng query thì bỏ cả query, vì một query mang đủ `state`+`code` chắc
 * chắn là callback chứ không phải tham số của app.
 */
function stripOidcCallback(candidate: string): string {
  const hashAt = candidate.indexOf("#");
  const beforeHash = hashAt < 0 ? candidate : candidate.slice(0, hashAt);
  const fragment = hashAt < 0 ? "" : candidate.slice(hashAt);

  const queryAt = beforeHash.indexOf("?");
  const path = queryAt < 0 ? beforeHash : beforeHash.slice(0, queryAt);
  const query = queryAt < 0 ? "" : beforeHash.slice(queryAt + 1);

  const head = isOidcCallbackParams(new URLSearchParams(query)) ? path : beforeHash;
  const tail = isOidcCallbackParams(new URLSearchParams(fragment.replace(/^#/, "")))
    ? ""
    : fragment;
  return head + tail;
}

export function sanitizeReturnTo(candidate: string | null): string {
  if (candidate == null) return "/";
  const cleaned = stripOidcCallback(candidate);
  if (!cleaned.startsWith("/")) return "/";
  if (cleaned.startsWith("//")) return "/";
  if (cleaned.startsWith("/\\")) return "/";
  if (cleaned === "/") return "/";
  if (cleaned.includes("\\")) return "/";
  return cleaned;
}

export function saveReturnTo(candidate: string): void {
  const safe = sanitizeReturnTo(candidate);
  if (safe === "/") {
    sessionStorage.removeItem(RETURN_TO_KEY);
    return;
  }
  sessionStorage.setItem(RETURN_TO_KEY, safe);
}

export function consumeReturnTo(): string {
  const stored = sessionStorage.getItem(RETURN_TO_KEY);
  sessionStorage.removeItem(RETURN_TO_KEY);
  return sanitizeReturnTo(stored);
}